import AppService from "../../Services/appService/AppService";
import Container from "../Helper/Container";
import images from "../../images";
import React, { useEffect, useState } from "react";
import Svg from "../Helper/Svg";
import translate from "../../Utils/translate";

const Accordion = ({ handleViewPassword, refetch, query }) => {
  const [activeApp, setActiveApp] = useState(null);
  const [apps, setApps] = useState();
  const [results, setResults] = useState({
    error: false,
    isGettingData: true,
  });

  useEffect(() => {
    fetchApps();
  }, [refetch]);

  const fetchApps = async () => {
    try {
      const apps = await AppService.getApps();
      setApps(apps);
      setResults({ isGettingData: false, error: false });
    } catch (error) {
      if (error.status !== 404) {
        setResults((prevState) => ({ ...prevState, error: true }));
      }
      setResults((prevState) => ({ ...prevState, isGettingData: false }));
      console.error(error.message, error.errors, error.status);
    }
  };

  const handleCollapse = (event, id) => {
    if (id === activeApp) {
      setActiveApp(null);
      return;
    }
    setActiveApp(id);
  };

  const getAccounts = (account, app) => {
    // this removes the array of accounts
    const { accounts, ...appData } = app;
    return (
      <button
        className="border-2 border-theme-secondary rounded-default p-default mb-default w-full"
        key={account.id}
        onClick={(event) => handleViewPassword(event, { ...appData, ...account })}
      >
        <div className="flex justify-between items-center w-full">
          <h1 className="ml-2">{account.username}</h1>

          <figure>
            <Svg icon={images.icons.eyeOpen} />
          </figure>
        </div>
      </button>
    );
  };

  if (results.isGettingData) {
    return (
      <Container className="flex justify-center bg-theme-secondary rounded-default">
        <h1 className="text-lg font-medium">{translate("loading")}</h1>
      </Container>
    );
  }

  if (results.error) {
    return (
      <Container className="flex justify-center bg-theme-secondary rounded-default">
        <h1 className="text-lg font-medium">{translate("errors.unexpected_error")}</h1>
      </Container>
    );
  }

  if (!apps) {
    return (
      <Container className="flex justify-center bg-theme-secondary rounded-default">
        <h1 className="text-lg font-medium">{translate("pages.account.no_accounts")}</h1>
      </Container>
    );
  }

  return apps
    ?.filter(
      (app) =>
        app.domain.toLowerCase().includes(query) ||
        app.appName.toLowerCase().includes(query) ||
        app.accounts.some((account) => account.accountName.toLowerCase().includes(query))
    )
    .map((app) => {
      const toggleActiveApp = activeApp !== app.domain ? "hidden" : "visible";
      const rotateArrow = activeApp === app.domain ? "rotate-180" : "rotate-0";

      return (
        <React.Fragment key={app.domain}>
          <button
            className="bg-theme-secondary rounded-default p-default mb-default w-full"
            onClick={(event) => handleCollapse(event, app.domain)}
          >
            <span className="flex justify-between items-center">
              <span className="flex items-center">
                <img src={app.img} alt={`logo of ${app.accountName} brand`} className="h-8 w-8 rounded-2xl" />
                <span className="ml-2">{app.appName}</span>
              </span>
              <Svg className={`${rotateArrow} transition-all`} icon={images.icons.arrow} />
            </span>
          </button>

          <div className={`${toggleActiveApp}`}>{app.accounts.map((account) => getAccounts(account, app))}</div>
        </React.Fragment>
      );
    });
};

export default Accordion;
